import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'leimma3';
const args = {};

export class Leimma3 extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
